export default __webpack_public_path__ + "static/media/illustration-study-3-n-m.be1a7e3d.webp";